// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Computer(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Computer" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 3H2V16.5H10.5V18.5H6V21H18V18.5H13.5V16.5H22V3ZM19.5 5.5H4.5V14H19.5V5.5Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Computer.js.map